import React from 'react';
import './declaracaoEspecifica.scss';

//Componentes
import Breadcrumbs from '../../components/breadcrumbs';
import NavigationButtons from '../../components/navigationButtons';
import Field from '../../components/field';
import Toggle from '../../components/toggle';
import CheckObligation from '../../components/checkObligation'
import Popover from '../../components/popover';
import iconInfo from '../../assets/images/icon_info.svg';
import Dropdown from '../../components/dropdown';
import Modal from '../../components/modal';
import { bool } from 'prop-types';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    color: 'green'
  }
});

const invalidNif = [
  "000000000",
  "111111111",
  "222222222",
  "333333333",
  "444444444",
  "555555555",
  "666666666",
  "777777777",
  "888888888",
  "999999999",
]

class DeclaracaoEspecifica extends React.Component {

  state = {
    openModal: false,
    minLengthNif: null
  }

  componentWillMount() {
    this.formFields = []
    let {
      getListRendaMensalAction,
      getListPatrimonioAction,
      configuracaoDdi,
      fillProfessionList,
      getListDeclaracaoAnualAction
    } = this.props;
    getListRendaMensalAction();
    getListPatrimonioAction();
    getListDeclaracaoAnualAction();
    configuracaoDdi();
    fillProfessionList();
  }

  openModal = (value) => {
    this.setState({openModal: value});
  }

  render() {
    let {
      listPais,
      loadingDdi
    } = this.props.ddi;

    let {
      dropdownDadosRendaMensalList,
      loadingListRendaMensal,
      dropdownDadosPatrimonioList,
      loadingListPatrimonio
    } = this.props.rendaPatrimonio;

    let {
      declaracoesEspecificasObrigatorias_ppe,
      declaracoesEspecificasObrigatorias_relacaoPessoaPpe,
      declaracoesEspecificasObrigatorias_socioPpe,
      declaracoesEspecificasObrigatorias_participanteFatca,
      declaracoesEspecificasObrigatorias_pessoaAmericana,
      declaracoesEspecificasObrigatorias_operacaoImportacao,
      declaracoesEspecificasObrigatorias_listaProfissao,
      formDeclaracaoPF,
      formDeclaracaoPJ,
      declaracoesEspecificasObrigatorias_nif,
      declaracoesEspecificasObrigatorias_nifCountry,
      declaracoesEspecificasObrigatorias_faixaRendaMensal,
      declaracoesEspecificasObrigatorias_faixaPatrimonio,
      dropdownDeclaracaoAnualList,
      declaracoesEspecificasObrigatorias_declaracaoAnual
    } = this.props.declaracaoEspecifica;
    
    let {
      changeDeclaracaoPFValueForm,
      changeDeclaracaoPJValueForm,
      handleChangeDeclaracaoSouPessoaFlag,
      handleChangeDeclaracaoRelacionamentoFlag,
      handleChangeDeclaracaoSocioFlag,
      handleChangeDeclaracaoFatcaFlag,
      handleChangeDeclaracaoPersonFlag,
      handleChangeDeclaracaoOperacaoImportacao,
      handleChangeDadosNIFCountry,
      handleChangeDadosRendaMensal,
      handleChangeDadosPatrimonio,
      changeProfession,
      handleChangeDeclaracaoAnual
    } = this.props; 

    return (
      <section className="container">
        <div className="col">
          <Breadcrumbs />
        </div>

        {/* =================pessoa Física========================== */}
        <CheckObligation field="declaracoesEspecificasObrigatorias_ocupacaoPrincipal" >
          {(validacoes) =>
            <div className="col">
                <Dropdown
                classSelect={"mt-0"}
                value={formDeclaracaoPF.declaracoesEspecificasObrigatorias_ocupacaoPrincipal}
                onChange={changeProfession}
                dataSource={declaracoesEspecificasObrigatorias_listaProfissao}
                required={true}
                returnObject={this.createRefFields}
                name="declaracoesEspecificasObrigatorias_ocupacaoPrincipal"
                label="Ocupação Profissional" 
              />
            </div>}
        </CheckObligation>

        <CheckObligation field="declaracoesEspecificasObrigatorias_faixaRendaMensal" >
          {(validacoes) =>
            <div className="col-50">
              <Dropdown
                label="Renda Mensal"
                name="declaracoesEspecificasObrigatorias_faixaRendaMensal"
                required={validacoes.obrigatorio}
                value={declaracoesEspecificasObrigatorias_faixaRendaMensal}
                onChange={handleChangeDadosRendaMensal}
                dataSource={dropdownDadosRendaMensalList}
                loading={loadingListRendaMensal}
                returnObject={this.createRefFields}
              />
            </div>}
        </CheckObligation>
        <CheckObligation field="declaracoesEspecificasObrigatorias_faixaPatrimonio" >
          {(validacoes) =>
            <div className="col-50">
              <Dropdown
                label="Patrimônio"
                name="declaracoesEspecificasObrigatorias_faixaPatrimonio"
                required={validacoes.obrigatorio}
                value={declaracoesEspecificasObrigatorias_faixaPatrimonio}
                onChange={handleChangeDadosPatrimonio}
                dataSource={dropdownDadosPatrimonioList}
                loading={loadingListPatrimonio}
                returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>

        <CheckObligation field="declaracoesEspecificasObrigatorias_ppe">
          {(validacoes) =>
            <div className="col">
              <div className="col-togle">
                <Toggle id="declaracoesEspecificasObrigatorias_ppe" check={declaracoesEspecificasObrigatorias_ppe} onChange={handleChangeDeclaracaoSouPessoaFlag} />
              </div>
              <div className="col-togle-p">
                <p>Sou pessoa politicamente exposta (PPE)</p>
              </div>
            </div>}
        </CheckObligation>
        <CheckObligation field="declaracoesEspecificasObrigatorias_relacaoPessoaPpe">
          {(validacoes) =>
            <div className="col icon">
              <div className="toggle">
                <Toggle id="declaracoesEspecificasObrigatorias_relacaoPessoaPpe" check={declaracoesEspecificasObrigatorias_relacaoPessoaPpe} onChange={handleChangeDeclaracaoRelacionamentoFlag} />
              </div>
              <div className="frase">
                <p>Tenho relacionamento com uma pessoa politicamente exposta (PPE)</p>
              </div>
              <div className="popover">
                <Popover message="Considera-se pessoa politicamente exposta aquela que desempenha ou tenha desempenhado, nos últimos cinco(5) anos, cargos, empregos ou outras funções públicas relevantes, no brasil ou outros países, territórios e dependências estratégicas, assim como seus representantes, familiares e outras pessoas de seu relacionamento próximo."
                  icon={iconInfo} />
              </div>
            </div>}
        </CheckObligation>
        {/* =================pessoa Juridica========================== */}
        <CheckObligation field="declaracoesEspecificasObrigatorias_operacaoImportacao">
          {(validacoes) =>
            <div className="col icon">
              <div className="toggle">
                <Toggle id="declaracoesEspecificasObrigatorias_operacaoImportacao" check={declaracoesEspecificasObrigatorias_operacaoImportacao} onChange={handleChangeDeclaracaoOperacaoImportacao} />
              </div>
              <div className="frase">
                <p>A Empresa irá realizar operação de importação?</p>
              </div>
              <div className="popover">
                <Popover message="Ao confirmar essa informação, será necessário enviar o documento de comprovante de imposto de renda."
                  icon={iconInfo} />
              </div>
            </div>}
        </CheckObligation>
        <CheckObligation field="declaracoesEspecificasObrigatorias_socioPpe">
          {(validacoes) =>
            <div className="col icon">
              <div className="toggle">
                <Toggle id="declaracoesEspecificasObrigatorias_socioPpe" check={declaracoesEspecificasObrigatorias_socioPpe} onChange={handleChangeDeclaracaoSocioFlag} />
              </div>
              <div className="frase">
                <p>Possui em seu quadro Sócio, Administrador ou representante legal pessoa exposta politicamente (PEP)</p>
              </div>
              <div className="popover">
                <Popover message="Considera-se pessoa politicamente exposta aquela que desempenha ou tenha desempenhado, nos últimos cinco(5) anos, cargos, empregos ou outras funções públicas relevantes, no brasil ou outros países, territórios e dependências estratégicas, assim como seus representantes, familiares e outras pessoas de seu relacionamento próximo."
                  icon={iconInfo} />
              </div>
            </div>}
        </CheckObligation>

        <CheckObligation field="declaracoesEspecificasObrigatorias_participanteFatca">
          {(validacoes) =>
            <div className="col">
              <div className="col-togle">
                <Toggle id="declaracoesEspecificasObrigatorias_participanteFatca" check={declaracoesEspecificasObrigatorias_participanteFatca} onChange={handleChangeDeclaracaoFatcaFlag} />
              </div>
              <div className="col-togle-p">
                <p>A Empresa é participante do FATCA (Foreign Account Tax Compliance Act)</p>
              </div>
            </div>}
        </CheckObligation>
        <CheckObligation field="declaracoesEspecificasObrigatorias_participanteGiin" fieldConditional={{ 'declaracoesEspecificasObrigatorias_participanteFatca': declaracoesEspecificasObrigatorias_participanteFatca }}>
          {(validacoes) =>
            <div className="col">
              <Field
                type="text"
                placeholder="999999999999999"
                required={validacoes.obrigatorio}
                label="Número do GIIN (Global Intermediary Identification Number)"
                name="declaracoesEspecificasObrigatorias_participanteGiin"
                mask="999999999999999"
                value={formDeclaracaoPJ.declaracoesEspecificasObrigatorias_participanteGiin}
                onChange={changeDeclaracaoPJValueForm}
                returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
         {/* =================pessoa Juridica e Física========================== */}
        <CheckObligation field="declaracoesEspecificasObrigatorias_pessoaAmericana">
          {(validacoes) =>
            <div className="col d-flex">
              <Dropdown
                classSelect={"mt-0"}
                disabled={this.props.possuiDomicilioFiscalEUA}
                value={declaracoesEspecificasObrigatorias_pessoaAmericana}
                onChange={handleChangeDeclaracaoPersonFlag}
                dataSource={[{name: 'Sim', value: true}, {name: 'Não', value: false}]}
                required={true}
                returnObject={this.createRefFields}
                name="declaracoesEspecificasObrigatorias_pessoaAmericana"
                label="Você é considerada uma Pessoa dos EUA - US Person?" 
              />
              <div className="popover">
                <Popover click={() => this.openModal(!this.state.openModal)} messageHidden={true} icon={iconInfo} />
              </div>
            </div>
             }           
        </CheckObligation>
        <CheckObligation field="declaracoesEspecificasObrigatorias_nif" fieldConditional={{ 'declaracoesEspecificasObrigatorias_pessoaAmericana': declaracoesEspecificasObrigatorias_pessoaAmericana }}>
          {(validacoes) =>
            <div className="col">
              <Field
                type="text"
                placeholder="999999999"
                required={validacoes.obrigatorio}
                label="Número de Identificação Fiscal (NIF/ Tax Identification Number) xxxxxxxxx ou xxx-xx-xxxx ou xx-xxxxxxx"
                name="declaracoesEspecificasObrigatorias_nif"
                // mask="999999999"
                value={declaracoesEspecificasObrigatorias_nif}
                onChange={this.handleChangeNif}
                minlength={this.state.minLengthNif === null ? this.minlengthNif(declaracoesEspecificasObrigatorias_nif) : this.state.minLengthNif}
                returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="declaracoesEspecificasObrigatorias_nifCountry" fieldConditional={{ 'declaracoesEspecificasObrigatorias_pessoaAmericana': declaracoesEspecificasObrigatorias_pessoaAmericana }}>
          {(validacoes) =>
            <div className="col">
              <Dropdown
                classSelect={"mt-0"}
                value={declaracoesEspecificasObrigatorias_nifCountry}
                onChange={handleChangeDadosNIFCountry}
                dataSource={listPais.map((p) => ({ value: p.IdPais, name: p.Nome }))}
                required={validacoes.obrigatorio}
                returnObject={this.createRefFields}
                loading={loadingDdi}
                label="País do NIF"
                name="declaracoesEspecificasObrigatorias_nifCountry" />
            </div>}
        </CheckObligation>

        <CheckObligation field="declaracoesEspecificasObrigatorias_declaracaoAnual" >
          {(validacoes) =>
            <div className="col">
              <Dropdown
                // classSelect={"mt-0"}
                value={declaracoesEspecificasObrigatorias_declaracaoAnual}
                onChange={handleChangeDeclaracaoAnual}
                dataSource={dropdownDeclaracaoAnualList}
                required={validacoes.obrigatorio}
                returnObject={this.createRefFields}
                label="Autodeclaração de faturamento dos últimos 12 meses"
                name="declaracoesEspecificasObrigatorias_declaracaoAnual"
                classLabel="top-0"
              />
            </div>}
        </CheckObligation>

        <div className="col">
          <NavigationButtons history={this.props.history} validateFields={this.validateFields} />
        </div>

        <Dialog
          open={this.state.openModal}
          onClose={() => this.openModal(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle 
            id="alert-dialog-title"
            style={{borderBottom: '1px solid gray'}}
          >
            <span style={{color: 'green'}}>Quem é considerada uma pessoa dos EUA - US Person?</span>
          </DialogTitle>
          <DialogContent style={{borderBottom: '1px solid gray'}}>
            <DialogContentText id="alert-dialog-description">
              <li>
                Um cidadão norte-americano que nasceu em qualquer lugar dos EUA ou em seus territórios, exceto os que tenham
                renunciado à cidadania;
              </li>
              <li>
                Um indivíduo que detenha dupla nacionalidade e passaporte americano, ainda que resida fora dos EUA;
              </li>
              <li>
                Um indivíduo que seja filho de pelo menos um cidadão norte-americano e um indivíduo cujo pais se tornaram cidadãos
                norte-americanos antes de tal indivíduo tenha completado 18 anos;
              </li>
              <li>
                Um indivíduo titular de conta em instituição financeira nos EUA;
              </li>
              <li>
                Um indivíduo que possui alguma fonte de renda nos EUA;
              </li>
              <li>
                Um indivíduo que possui participação societária de mais de 10% em empresa nos EUA;
              </li>
              <li>
                Residentes permanentes nos EUA (incluindo detentores de green card);
              </li>
              <li>
                Pessoas que tenham residido nos EUA ou em seus territórios por mais de 30 dias durante o ano  corrente ou que
                tenham residido por mais de 180 dias durante os últimos 3 anos, incluindo o ano corrente e os dois imediatamente
                anteriores;
              </li>
              <li>
                Uma empresa constituída sob as leis dos EUA (Domestic Partnership ou Sociedade Doméstica);
              </li>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button 
              variant="contained" 
              onClick={() => this.openModal(false)} 
              autoFocus
              style={{backgroundColor: 'green'}}
            >
              <span style={{color: 'white'}}>OK</span>
            </Button>
          </DialogActions>
        </Dialog>
      </section>
    );
  }

  handleChangeNif = (name, value) => {
    if (!this.validationNIF(value))
      return;    

    this.setState({...this.state, minLengthNif: this.minlengthNif(value)});

    const {changeDeclaracaoNIF} = this.props;
      changeDeclaracaoNIF(value);
  }

  createRefFields = (self) => {
    this.formFields[self.props.name] = self
  }

  minlengthNif = value => {
    if (value !== undefined && value !== null && value.split("-").length === 2) {
      return 10
    } else if (value !== undefined && value !== null && value.split("-").length === 3) {
      return 11
    } else {
      return 9
    }
  }

  validationNIF = (nif) => { 

    if (nif.match("^[0-9/-]*$") === null || nif.replaceAll("-", "").length > 9 || nif.split("-").length > 3)
      return false;
  
    // var nifReplace = nif.replaceAll("-", "");
    // if (invalidNif.some(x => nifReplace === x))
    //   return false;
  
    if (nif.charAt(nif.length - 1) === '-' && (
        (nif.length !== 3 && nif.length !== 4 && nif.length !== 7) || 
        (nif.length === 4 && nif.charAt(2) === '-') || 
        (nif.length === 7 && nif.charAt(3) !== '-')
      )
    )
      return false;
  
    if ((nif.includes("-") && (nif.length > 2 && nif.charAt(2) !== "-") && (nif.length > 3 && nif.charAt(3) !== "-") && (nif.length > 6 && nif.charAt(6) !== "-")) ||
      (nif.length >= 7 && nif.charAt(3) === "-" && nif.charAt(6) !== "-") ||
      (nif.charAt(2) === "-" && nif.split("-").length > 2) ||
      (nif.length >= 7 && nif.charAt(6) === "-" && nif.charAt(3) !== "-")
    )
      return false;
  
    return true;
  }

  validateFields = async () => {
    let list = []
    let countMounted = 0

    return new Promise(resolve => {
      if (Object.keys(this.formFields).length === 0) {
        resolve([])
      }
      for (let key in this.formFields) {
        if (this.formFields[key]._isMounted) {
          countMounted++
          this.formFields[key].validate(this.formFields[key].input)

            // eslint-disable-next-line no-loop-func
            .then(r => {
              list.push({ name: this.formFields[key].props.name, valid: r })

              if (countMounted === list.length) {
                resolve(list)
              }
            })
        }
      }
      if (countMounted === list.length) {
        resolve(list)
      }
    })
  }
}

export default DeclaracaoEspecifica;
